module.exports = __webpack_public_path__ + "static/media/appetizer-long.abd809c2.svg";